import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useStores } from '../../hooks/use-stores';
import { Typography, Box, Grid } from '@material-ui/core';
import Loader from '../../components/Loader';
import ProductCardType2 from '../../components/ProductCards/ProductCardType2';

const Favorites = observer(() => {
    const { FavoritesStore: store } = useStores();

    // Effects
    useEffect(() => {
        store.getFavorites();

        return () => {
            store.resetStore();
        };
    }, [store]);

    // Renders
    const renderContent = () => {
        return store.favorites.map((item, i) => (
            <Grid key={item.id} item xs={12} sm={6} lg={4}>
                <ProductCardType2
                    data={item}
                    isFavoriteDefault={true}
                    onToggleFavorite={store.toggleFavorite}
                    disabled={store.toggleLoading}
                />
            </Grid>
        ));
    };

    if (store.loading) {
        return <Loader />;
    }

    if (!store.loading && store.favorites.length === 0) {
        return (
            <Box py={10} px={5} textAlign="center">
                <Typography>Вы пока не добавили ни одного товара в избранное.</Typography>
            </Box>
        );
    }

    return (
        <Box mb={10}>
            <Grid container spacing={5}>
                {!store.loading && store.favorites?.length && renderContent()}
            </Grid>
        </Box>
    );
});

export default Favorites;
